export { default } from './publication-item';
